import Vue from 'vue'
import { S, G, M, A } from './types'
import { Getters, Mutations, Actions } from 'vuex'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  currentInstruction: null
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  currentInstruction: state => state.currentInstruction
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  setCurrentInstruction: (state, medicationInstruction) => {
    state.currentInstruction = medicationInstruction
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async fetchLatest({ commit }, { patientId }) {
    const response = await Vue.$api.medicationInstruction.fetch({ patientId })
    commit('setCurrentInstruction', response.length > 0 ? response[0] : null)
  },

  async patch({ commit }, { patientId, medicationInstructionId, payload }) {
    const response = await Vue.$api.medicationInstruction.patch({
      patientId,
      medicationInstructionId,
      payload
    })

    commit('setCurrentInstruction', response)
  },

  async create({ commit }, { patientId, payload }) {
    const response = await Vue.$api.medicationInstruction.create({
      patientId,
      payload
    })
    commit('setCurrentInstruction', response)
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
